import FullCalendar from "@fullcalendar/react"

// FullCalendar plugins (DO NOT REORDER)
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid"
import classNames from 'classnames'

import "@fullcalendar/common/main.css"
import "@fullcalendar/daygrid/main.css"
import "@fullcalendar/timegrid/main.css"

export const eventColors = {
	red: { bg: 'bg-red-50 dark:bg-red-500/10', text: 'text-red-500 dark:text-red-100', dot: 'bg-red-500' },
	orange: { bg: 'bg-orange-300 dark:bg-orange-500/10', text: 'text-gray-900 dark:text-white-100', dot: 'bg-orange-500' },
	amber: { bg: 'bg-amber-50 dark:bg-amber-500/10', text: 'text-amber-500 dark:text-amber-100', dot: 'bg-amber-500' },
	yellow: { bg: 'bg-yellow-50 dark:bg-yellow-500/10', text: 'text-yellow-500 dark:text-yellow-100', dot: 'bg-yellow-500' },
	lime: { bg: 'bg-lime-50 dark:bg-lime-500/10', text: 'text-lime-500 dark:text-lime-100', dot: 'bg-lime-500' },
	green: { bg: 'bg-green-300 dark:bg-green-300/10', text: 'text-gray-900 dark:text-black-100', dot: 'bg-green-500' },
	emerald: { bg: 'bg-emerald-50 dark:bg-emerald-500/10', text: 'text-emerald-500 dark:text-emerald-100', dot: 'bg-emerald-500' },
	teal: { bg: 'bg-teal-50 dark:bg-teal-500/10', text: 'text-teal-500 dark:text-teal-100', dot: 'bg-teal-500' },
	cyan: { bg: 'bg-cyan-50 dark:bg-cyan-500/10', text: 'text-cyan-500 dark:text-cyan-100', dot: 'bg-cyan-500' },
	sky: { bg: 'bg-sky-50 dark:bg-sky-500/10', text: 'text-sky-500 dark:text-sky-100', dot: 'bg-sky-500' },
	blue: { bg: 'bg-blue-500 dark:bg-blue-500/10', text: 'text-white-500 dark:text-white-100', dot: 'bg-blue-500' },
	indigo: { bg: 'bg-indigo-50 dark:bg-indigo-500/10', text: 'text-indigo-500 dark:text-indigo-100', dot: 'bg-indigo-500' },
	purple: { bg: 'bg-purple-400 dark:bg-purple-400/10', text: 'text-white-500 dark:text-white-100', dot: 'bg-purple-500' },
	fuchsia: { bg: 'bg-fuchsia-50 dark:bg-fuchsia-500/10', text: 'text-fuchsia-500 dark:text-fuchsia-100', dot: 'bg-fuchsia-500' },
	pink: { bg: 'bg-pink-50 dark:bg-pink-500/10', text: 'text-pink-500 dark:text-pink-100', dot: 'bg-pink-500' },
	rose: { bg: 'bg-rose-50 dark:bg-rose-500/10', text: 'text-rose-500 dark:text-rose-100', dot: 'bg-rose-500' },
	gray: { bg: 'bg-gray-200 dark:bg-gray-500/10', text: 'text-gray-500 dark:text-gray-100', dot: 'bg-gray-500' },
	wine: { bg: 'bg-wine dark:bg-wine', text: 'text-wine dark:text-wine', dot: 'bg-wine' },
	darkGray: { bg: 'bg-darkgray dark:bg-darkgray', text: 'text-darkgray dark:text-darkgray', dot: 'bg-darkgray' },
}

const CalendarView = (props) => {
	debugger
	const { wrapperClass,loading, ...rest} = props;
  
	// useEffect(() => {
	//   setTimeout(() => {
	// 	setLoading(false); // Set loading to false once data is fetched
	//   }, 4000); // You can adjust the time based on your actual data fetch
	// }, []);
  
	return (
	  <div className={classNames('calendar', wrapperClass)}>
		{/* Loading spinner when data is being fetched */}
		<style>{`
			.calendar .fc .fc-daygrid-event {
				margin-bottom: 0 !important;
			}
			`}
		</style>
		{loading ? (
		  <div className="flex justify-center items-center h-full">
			<div className="loader"></div> {/* Add your loading spinner */}
		  </div>
		) : (
		  <FullCalendar
			initialView="dayGridMonth"
			headerToolbar={{
			  left: 'title',
			  center: '',
			  right: 'dayGridMonth prev,next',
			}}
			eventContent={(arg) => {
				debugger
			  const { extendedProps } = arg.event;
			  const { isEnd, isStart } = arg;
			  return (
				<div
				  className={classNames(
					'custom-calendar-event',
					extendedProps.eventColor ? eventColors[extendedProps.eventColor]?.bg : '',
					extendedProps.eventColor ? eventColors[extendedProps.eventColor]?.text : '',
					isEnd && !isStart && '!rounded-tl-none !rounded-bl-none !rtl:rounded-tr-none !rtl:rounded-br-none',
					!isEnd && isStart && '!rounded-tr-none !rounded-br-none !rtl:rounded-tl-none !rtl:rounded-bl-none'
				  )}
				>
				  {/* Event Title */}
				  <span className="font-semibold ml-1 rtl:mr-1">{arg.event.title}</span>
  

				  {extendedProps.isRelocation && (
					<span className="inline-block w-4 h-4 rounded-full ml-2" style={{ backgroundColor: '#F9E300',

						position: 'absolute',
						right: '5px', // Adjust this to position the text horizontally
						color: 'black',
						zIndex: 1,
					 }}></span>
				  )}

				  {!extendedProps.isRelocation && extendedProps.isStartDot && (
					<span className="inline-block w-4 h-4 rounded-full ml-2" style={{ backgroundColor: '#885C29',
						position: 'absolute',
						right: '25px', // Adjust this to position the text horizontally
						color: 'black',
						zIndex: 1,
					
					 }}></span>
				  )}
  
				  {!extendedProps.isRelocation && extendedProps.isEndDot && (
					<span className="inline-block w-4 h-4 rounded-full ml-2" style={{ backgroundColor: 'red',

						position: 'absolute',
						right: '5px', // Adjust this to position the text horizontally
						color: 'black',
						zIndex: 1,
					 }}></span>
				  )}
  
				  {/* Circle with Text */}
				  {!extendedProps.isStartDot && !extendedProps.isEndDot && extendedProps.plannedText && (
					<span
					  className="inline-flex items-center justify-center w-6 h-6 rounded-full text-white text-xs"
					  style={{
						position: 'absolute',
						right: '5px', // Adjust this to position the text horizontally
						backgroundColor: extendedProps.circleColor || 'white',
						color: 'black',
						zIndex: 1, // Make sure it's above other content
					  }}
					>
					  {extendedProps.plannedText}
					</span>
				  )}
				</div>
			  );
			}}
			plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
			{...rest}
		  />
		)}
	  </div>
	);
  };
  

export default CalendarView
